import React, { memo } from 'react'

import { string } from 'prop-types'

function MarmosetSlide({ fileUrl }) {
  // Always render the container div so useCarousel can find it
  // useCarousel will handle the initialization based on activeIndex
  return (
    <div
      className="gallery-area-top-carousel__other-media"
      data-type="marmoset"
      data-src={fileUrl}
    />
  )
}

MarmosetSlide.propTypes = {
  fileUrl: string.isRequired,
}

export default memo(MarmosetSlide)
